import { CardBase } from "./card.base";
import { CardBody } from "./components/body/cardBody.component";
import { CardFooter } from "./components/footer/cardFooter.component";
import { CardHeader } from "./components/header/cardHeader.component";
import { CardImage } from "./components/image/cardImage.component";
import { CardLink } from "./components/link/cardLink.component";
import { CardText } from "./components/text/cardText.component";
import { CardTitle } from "./components/title/cardTitle.component";

export const Card = Object.assign(CardBase, {
    Body: CardBody,
    Header: CardHeader,
    Footer: CardFooter,
    Title: CardTitle,
    Image: CardImage,
    Text: CardText,
    Link: CardLink
});
